import { render, staticRenderFns } from "./LoginRegisterDesktop.vue?vue&type=template&id=47173112"
import script from "./LoginRegisterDesktop.vue?vue&type=script&lang=js"
export * from "./LoginRegisterDesktop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports